export default {"src":"/_next/static/media/inquiry.e1305559.svg","height":90,"width":82,"blurWidth":0,"blurHeight":0};